export default {
      id: "play-usage",
      viewBox: "0 0 95 95",
      url: __webpack_public_path__ + "sprite.svg#play",
      toString: function () {
        return this.url;
      }
    }